export default __webpack_public_path__ + "static/media/Malice Band.8a1f1433.jpg";